module.exports = __webpack_public_path__ + "img/Contact_material_s.d34001d5.jpeg";